export default {
    breadcrumbs: {
        home: 'Početna',
        manage_account: 'Upravljanje nalogom',
        preview: 'Pregled naloga',
        user_profile: 'Profil korisnika',
    },
    offer_tabs: {
        active: 'Aktivni ({number})',
        renewal: 'Za obnovu ({number})',
        expired: 'Istekli ({number})',
    },
    tabs: {
        offers: 'Usluge',
    },
    modal: {
        complete_profile: 'Za pregled naloga popunite ime i prezime!',
        delete_profile: 'Da li ste sigurni da želite obrisati profil?',
    },
    delete_profile_button: 'Obrišite nalog',
}
